import { makeStyles } from '@material-ui/core';

const useFormDataGroupsStyles = makeStyles((theme) => {
  return ({
    dataGroupWithSingleFieldContainer: {
      display: 'flex',
      '& img': {
        marginLeft: '5px'
      }
    },
    dataGroupWithMultiFieldsContainer: {
      display: 'flex',
      marginBottom: '20px',
      justifyContent: 'space-between',
      '& h1': {
        color: 'var(--neutrals-black)',
        fontSize: 'var(--h1-text-size)',
        fontFamily: 'var(--font-family-bold)',
        fontWeight: 500,
        lineHeight: 1.167
      }
    },
    removeImg: {
      cursor: 'pointer'
    },
    hideRemoveImg: {
      visibility: 'hidden'
    }
  });
});

export default useFormDataGroupsStyles;